"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _imageService = require("./imageService");

var _imageService2 = _interopRequireDefault(_imageService);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ImgurService = function (_ImageService) {
  _inherits(ImgurService, _ImageService);

  function ImgurService(_ref) {
    var _ref$clientId = _ref.clientId,
        clientId = _ref$clientId === undefined ? "" : _ref$clientId,
        mashapeKey = _ref.mashapeKey;

    _classCallCheck(this, ImgurService);

    var _this = _possibleConstructorReturn(this, (ImgurService.__proto__ || Object.getPrototypeOf(ImgurService)).call(this));

    _this.clientId = clientId;
    _this.mashapeKey = mashapeKey;
    return _this;
  }

  _createClass(ImgurService, [{
    key: "getServiceConfig",
    value: function getServiceConfig() {
      if (this.mashapeKey) {
        return {
          name: "image",
          accept: "image/*",
          action: "https://imgur-apiv3.p.mashape.com/3/image",
          headers: {
            "X-Mashape-Key": this.mashapeKey,
            Authorization: "Client-ID " + this.clientId,
            "X-Requested-With": null // https://github.com/react-component/upload/issues/33

          }
        };
      }

      return {
        name: "image",
        accept: "image/*",
        action: "https://api.imgur.com/3/image",
        headers: {
          Authorization: "Client-ID " + this.clientId,
          "X-Requested-With": null // https://github.com/react-component/upload/issues/33

        }
      };
    }
  }]);

  return ImgurService;
}(_imageService2.default);

exports.default = ImgurService;